import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addPhasesAction,
    updatePhasesAction,
    deletePhasesAction
} from '../../../redux/actions/admin/adminAction';

export const Phase = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'phase': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'phase': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updatePhase(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addPhase(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deletePhase(id)
    }

    const [phasesColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Phase", field: 'phase', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])


    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.phases}
                defaultColDef={defaultColDef}
                columnDefs={phasesColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Phases</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>Phase</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="phase"
                                name="phase"
                                value={inputData.phase}
                                onChange={handleChange}
                                placeholder="Phase"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const phases = state.admin.phases;
    return {
        phases: phases,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addPhase: (data) => dispatch(addPhasesAction(data)),
        updatePhase: (id, data) => dispatch(updatePhasesAction(id, data)),
        deletePhase: (id) => dispatch(deletePhasesAction(id)),

    };
};



export default connect(mapStateToProps, mapDispatchToProps)(Phase)


